<app-i18n-dictionary>
    <span [attr.transid]="deleteQuoteMessageTextId" i18n="@@quote-card_delete-quote-confirmation-message">Do you really
        want to delete this quote?
    </span>
    <span [attr.transid]="viewQuoteMessageTextId" i18n="@@quote-card_view-quote-message">View</span>
    <span [attr.transid]="downloadQuoteMessageTextId" i18n="@@quote-card_download-quote-message">Download as PDF</span>
</app-i18n-dictionary>

<div class="disabled loading-spinner" *ngIf="isPending">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="quote-information" (click)="onQuoteClick()">
    <div class="quote-metadata">
        <div class="quote-data">
            <div>Quote name:</div>
            <div>{{quoteName}}</div>
        </div>

        <div *ngIf="!hasRequestData" class="quote-data">
            <div i18n="@@quote-card_creation-date">Creation date:</div>
            <div>{{quote.creationDate | date}}</div>
        </div>

        <div *ngIf="hasRequestData" class="quote-data">
            <div i18n="@@quote-card_request-date">Requested date:</div>
            <div>{{request.requestDate | date}}</div>
        </div>

        <div class="quote-data">
            <div i18n="@@quote-card_product-count">Products:</div>
            <div>{{quote.quoteItems.length}}</div>
        </div>
    </div>

    <div class="delete-btn">
        <button (click)="openDeleteConfirmationDialog($event)" *ngIf="!isPending && isMutable" [disabled]="isPending"
                mat-icon-button>
            <mat-icon>delete</mat-icon>
        </button>

        <button class="dummy-btn" *ngIf="!isPending && !isMutable" [ngClass]="{'is-hidden': !isMutable}"
                [disabled]="!isMutable"
                mat-icon-button>
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>
